import React from 'react';
import { File, FileText, FileSpreadsheet, FileImage, Mail } from 'lucide-react';

const EXTENSION_ICON_MAP = {
  jpg: FileImage,
  jpeg: FileImage,
  png: FileImage,
  bmp: FileImage,
  doc: FileText,
  docx: FileText,
  xls: FileSpreadsheet,
  xlsx: FileSpreadsheet,
  pdf: FileText,
  eml: Mail,
  msg: Mail,
};

export const FileIcon = ({ extension = '', className = 'h-4 w-4' }) => {
  const Icon = EXTENSION_ICON_MAP[extension.toLowerCase()] || File;
  return <Icon className={className} />;
};
